import React from "react";
import { Editor } from "primereact/editor";
import HeaderEditorTemplate from "../../../../../components/NewProduct/components/HeaderEditorTemplate/HeaderEditorTemplate";

function RichTextField({ value, onChange, placeholder }) {
  return (
    <div className="product-form-char-editor">
      <Editor
        value={value || ""}
        onTextChange={(e) => onChange(e.htmlValue || "")}
        headerTemplate={<HeaderEditorTemplate />}
        style={{ height: "220px" }}
        placeholder={placeholder}
      />
    </div>
  );
}

export default RichTextField;
